import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
`
